// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {Products_cards} from '../free_proxy/product_cards';
import {use_prices} from '../plans/use_prices';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import {product_names} from '../products/products';
import {Pricing_widget, t_pricing_widget_type} from '../pricing_widget';
import {Select} from '../../../../hola/pub/lib/select';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import styles from '../../pages/toolip.io/dashboard.module.less';

const {SDC, DDC, RES, ISP, ISPPREM} = Proxy_type;

interface i_pricing_cards_props {
    skip?: Proxy_type[];
}
export const Pricing_cards = (props: i_pricing_cards_props)=>{
    const {skip} = props;
    const {get_url} = use_pathname();
    const {prices} = use_prices();
    return <Products_cards shown={true} bg={<></>} cls={styles.pricing_cards}
      get_cta={type=>{
        const p = prices[type];
        const val = p?.ips_amount?.[0]
          ? `${p.min_price_per_ip}/IP`
          : `${p.min_price_per_gb}/GB`;
        return {size: 'sm', to: get_url({type, page: 'pricing'}),
          caption: `Starting at $${val}`};
      }} skip={skip}
    />;
};

export const Pricing_plans = ()=>{
    const {params, set} = use_pathname();
    const title = params.type
        ? `${product_names[params.type]} Proxies`
        : 'Pricing plans';
    const items = [SDC, DDC, RES, ISP, ISPPREM].map(value=>{
        return {
            value,
            title: product_names[value],
        };
    });
    const on_select = (_name, value)=>{
        set({type: value});
    };
    return <div className={cn(styles.pricing_plans, params.type
      && styles.type_plans)}>
      <h3 className={cn(styles.panel_header, styles.plans_content)}>
        {title}</h3>
      {params.type ? <>
        <div className={styles.type_select}>
          <Select items={items} value={params.type} label={'Proxy type'}
            on_select={on_select} borderless size='md'
          />
        </div>
        <Pricing_widget def_type={params.type as t_pricing_widget_type}
          title={''}
          subtitle={''}
          type_slider={false}
          with_need_help={true}
          cls={styles.pricing_widget}
          sliders_pos="left"
        />
        <div className={styles.other}>
          <Pricing_cards skip={[params.type as Proxy_type]}/>
        </div>
      </> : <Pricing_cards/>}
    </div>;
};
